// extracted by mini-css-extract-plugin
module.exports = {"root":"FullBlock-module--root--3k1cX utilities-module--full--20TW4"};